export enum ObjectType {
    ROOT = 1,
    CATEGORY = 90,
    PROCESS = 20,
    VERSION = 16,
    ACTIVITY = 13,
    SUBPROCESS = 15,

    REUSABLE_GROUP = "REUSABLE_GROUP",
    EMBEDDED_GROUP = "EMBEDDED_GROUP"
}
